/**
 * web获取行情接口
 */

import delayparams from "../url/delayQuote"
import { quoteUrl } from "../../config/config"
import merge from "lodash/merge"
import forIn from "lodash/forIn"
import user from "../user"

let ut = "f057cbcbce2a86e2866ab8877db1d059"

let thisuser = user.get()

/**
 * 获取一组行情代码的行情数据
 * @param ids
 * @returns
 */
export async function getQuoteByIDList(ids: Array<string>): Promise<null | Array<{
  name: string
  code: string
  market: number
  new_price: number
  zde: number
  zdf: number
  f1: number
  f152: number
}>> {
  try {
    let backdata = await $.ajax({
      url: `${quoteUrl.getPath("quote")}api/qt/ulist.np/get?${delayparams.substring(1)}&cb=?`,
      data: {
        secids: ids.join(","),
        fields: "f1,f2,f3,f4,f12,f13,f14,f152",
        invt: 2,
        fltt: 1,
        ut,
      },
      dataType: "jsonp",
      type: "get",
    })
    if (backdata?.data?.diff instanceof Array) {
      return backdata.data.diff.map((v: any) => {
        return {
          f1: v.f1,
          new_price: v.f2,
          zdf: v.f3,
          zde: v.f4,
          code: v.f12,
          market: v.f13,
          name: v.f14,
          f152: v.f152,
        }
      })
    }
  } catch (error) {
    console.error(error)
  }

  return null
}

/**
 * 获取延迟参数
 */
export async function getDelayParam() {
  return await $.ajax({
    url: `${quoteUrl.getPath("quote")}api/qt/stock/get?${delayparams.substring(1)}`,
    type: "get",
    data: {
      ut,
    },
  })
}

/**
 * 获取行情数据
 * @param param
 * @param stockCodes
 * @param sort
 * @returns
 */
interface QuoteResult {
  data: Array<{
    name: string
    code: string
    market: number
    new_price: number
    zde: number
    zdf: number
    f1: number
    f19: number
    f128: number
    f152: number
  }>
  total: number
}

export async function getQuoteList(param: { pindex: number; psize: number; st: string; sr: number; cmd: string }, stockCodes: Array<string>, sort?: boolean): Promise<null | QuoteResult> {
  const result: QuoteResult = {
    data: [],
    total: 0,
  }
  try {
    let backdata = await $.ajax({
      url: quoteUrl.getPath("quote") + "api/qt/ulist/get?cb=?",
      data: {
        secids: stockCodes.join(","),
        fields: "f1,f2,f3,f4,f12,f13,f14,f19,f128,f152",
        invt: 2,
        fltt: 1,
        nzp: 1,
        pn: param.pindex,
        pz: sort ? param.pindex * param.psize : stockCodes.length,
        fid: param.st,
        po: param.sr,
        ut,
        np: 1,
      },
      dataType: "jsonp",
      type: "get",
    })

    if (backdata && backdata.data && backdata.data.diff) {
      const res = backdata.data
      result.data = res.diff.map((item: any) => {
        return {
          f1: item.f1,
          new_price: item.f2,
          zdf: item.f3,
          zde: item.f4,
          code: item.f12,
          market: item.f13,
          name: item.f14,
          f19: item.f19,
          f128: item.f128,
          f152: item.f152,
        }
      })
      result.total = res.total
    }
  } catch (error) {
    console.error(error)
  }
  return result
}

export async function getQuoteList_post(param: { pindex: number; psize: number; st: string; sr: number; cmd: string }, stockCodes: Array<string>): Promise<null | QuoteResult> {
  const result: QuoteResult = {
    data: [],
    total: 0,
  }
  try {
    let backdata = await $.ajax({
      url: quoteUrl.getPath("quote") + "api/qt/ulist.np/post",
      // url: `https://push2test.eastmoney.com/api/qt/ulist.np/post`,
      type: "post",
      headers:{
        "Content-Type": 'application/json',
        "dataType": "json",
        ut,
      },
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      data: JSON.stringify({
        secids: stockCodes,
        fields: "f1,f2,f3,f4,f12,f13,f14,f19,f128,f152",
        invt: 2,
        fltt: 1,
        nzp: 1,
        pn: param.pindex,
        pz: stockCodes.length,
        fid: param.st,
        po: param.sr,
        np: 1,
        dect: 1
      }),
    })
    if (backdata && backdata.data && backdata.data.full) {
      const res = backdata.data

      //CME合规
      if(thisuser == null && res.full && res.full.length){
        res.full.forEach(function(item:any){
          if(item.f13 == 101 || item.f13 == 102 || item.f13 == 103){
            
            forIn(item, function(value, key) {
              if(key != "f12" && key != "f13" && key != "f14"){
                item[key] = "-"
              }
            })
          }
        })
      }

      result.data = res.full.map((item: any) => {
        return {
          f1: item.f1,
          new_price: item.f2,
          zdf: item.f3,
          zde: item.f4,
          code: item.f12,
          market: item.f13,
          name: item.f14,
          f19: item.f19,
          f128: item.f128,
          f152: item.f152,
        }
      })
      result.total = res.total
    }
  } catch (error) {
    console.error(error)
  }
  return result
}

/**
 * 获取一个个股的详细行情数据
 * @param stockCode market.code
 * @param fields 需要请求的行情字段
 * @param dect 小数位数控制类型
 * @returns
 */
export async function getStockDetailData(stockCode: string, fields: string, dect = 0) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/get?cb=?" + delayparams,
    data: {
      secid: stockCode,
      forcect: 1,
      fields,
      ut,
      fltt: 1,
      invt: 2,
      dect
    },
    dataType: "jsonp",
  })
  if (backdata && backdata?.data) {
    // console.info(backdata.data)

    //CME合规处理
    if(thisuser == null && (stockCode.indexOf('101.') == 0  || stockCode.indexOf('102.') == 0  || stockCode.indexOf('103.') == 0)){
      Object.keys(backdata.data).forEach(function(key:any){
        if(key == 'f107' || key == 'f58' || key == 'f57'){
        }
        else{
            backdata.data[key] = '-'
        }
      })
    }

    
    return backdata.data
  }
  return null
}

let quotedata_cache = {}

/**
 * 获取一个个股的详细行情数据_推送
 * @param stockCode market.code
 * @param fields 需要请求的行情字段
 * @returns
 */
export function getStockDetailDataSSE(stockCode: string, fields: string, callback: Function) {
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/stock/sse?secid=${stockCode}&forcect=1&fields=${fields}&ut=${ut}&fltt=1&invt=2&mpi=1000${delayparams}`)

  sse.onmessage = function (output) {
    if (output?.data) {
      let quotedata = JSON.parse(output.data)
      if (quotedata.full == 1 && quotedata.data) {
        quotedata_cache = quotedata.data
      } else if (quotedata.full == 0 && quotedata.data) {
        quotedata_cache = merge({}, quotedata_cache, quotedata.data)
      }
      callback(quotedata_cache)
    }
  }
  return sse
}

/**
 * 获取新三板转板数据
 * @param stockCode market.code
 * @returns
 */
 export async function getStockNoticeDetailData(stockCode: string) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("datacenter") +'web/api/data/v1/get?',
    data: {
      reportName: 'RPT_CONF_DMSKIPO',
      columns: 'SECURITY_CODE_PAST,SECURITY_CODE,SECURITY_CODE_HQPAST,SECURITY_CODE_HQ,SECUCODE,SECURITY_INNER_CODE,SECURITY_NAME_ABBR,ISSUE_PRICE,EXPECT_ISSUE_NUM,APPLY_DATE,LISTING_DATE,ISSUE_PRICE_UPPER,ISSUE_PRICE_UPPER,APPLY_DATE_START,APPLY_DATE_END',
      quoteColumns: '',
      filter: `(SECURITY_CODE_HQPAST="SZ${stockCode}")`,
      pageNumber: 1,
      pageSize: 200,
      sortTypes: '',
      sortColumns: '',
      source: 'WAP',
      client: 'WAP',
    },
    dataType: 'json',
  })
  if (backdata && backdata.result && backdata.result.data) {
    return backdata.result.data
  }
  return null
}


/**
 * 获取退市整理剩余交易天数
 * @param datacode //数据代码 如 300059.SZ 831445.BJ
 * @returns 
 */
export async function GetDelistingDay(market: string | null, code:string):Promise<{
  CONTENT: string
}> {

  var datacode = code + '.SH'
  if(market == '0') datacode = code + '.SZ'
  if(code.indexOf('92') == 0) datacode = code + '.BJ'
  if(market == null) datacode = code


  try {
    let back = await $.ajax({
      url: `${quoteUrl.getPath("datacenter")}api/data/v1/get?callback=?`,
      type: 'GET',
      dataType: 'json',
      data: {
        reportName: `RPT_F10_REMIND_DAYSREM`,
        columns: `SECUCODE,SECURITY_CODE,SECURITY_INNER_CODE,ORG_CODE,EVENT_TYPE,LEVEL1_CONTENT`,
        source: `WAP`,
        client: `WAP`,
        filter: `(SECUCODE="${datacode}")`,
      }
    })

    if(back?.result?.data instanceof Array && back.result.data.length > 0){
      if(back.result.data[0]?.LEVEL1_CONTENT){
        return {
          CONTENT: back.result.data[0].LEVEL1_CONTENT
        }
      }
    }    
  } catch (error) {
    
  }

  return {CONTENT: ''}
}



/**
 * 获取在北交所上市转码的代码 920
 * @param code 
 * @returns 
 */
export async function getBJCCodeTrans(code:string) {
  try {

    let back = await $.ajax({
      url: quoteUrl.getPath("datacenter") + `securities/api/data/v1/get?callback=?`,
      type: 'GET',
      dataType: 'jsonp',
      data: {
        reportName: `RPT_BJS_CORRECODE_TIPS`,
        columns: `SECURITY_CODE,SECUCODE,CORRECODE,CORRE_SECUCODE,SECURITY_INNER_CODE,CORRE_INNER_CODE,TRADE_MARKET_CODE,CORRECODE_MARKET_CODE,SECURITY_TYPE_CODE,CORRE_TYPE_CODE,LISTING_DATE,CORRE_LISTING_DATE,ORG_CODE,IS_CHANGE`,
        quoteColumns: '',
        filter: '',
        pageNumber: 1,
        pageSize: 600,
        sortTypes: '',
        sortColumns: '',
        source: 'WEB',
        client: 'XinSanBanWeb'
      }
    })
    

    if(back?.result?.data instanceof Array && back.result.data.length > 0){
      if(back.result.data.some((v: { SECUCODE: string })=>v.SECUCODE == code + '.NQ')){
        return back.result.data.find((v: { SECUCODE: string })=>v.SECUCODE == code + '.NQ').CORRECODE
      }
    }
  } catch (error) {
    console.error(error)
  }
  return null
}

/**
 * 获取个股的右侧分时成交数据
 * @param stockCode market.code
 * @returns
 */
export async function getStockRightFSData(stockCode: string, pageSize=15) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/details/get?cb=?" + delayparams,
    data: {
      secid: stockCode,
      forcect: 1,
      fields1: "f1,f2,f3,f4,f5",
      fields2: "f51,f52,f53,f54,f55",
      pos: `-${pageSize}`,
      iscca: 1,
      invt: 2,
      ut,
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })
  let dataArr: Array<string> = []
  if (backdata != null && backdata.data != null && backdata.data.details != null && backdata.data.details.length > 0) {
    for (let item = backdata.data.details.length - 1; item >= 0; item--) {
      dataArr.push(backdata.data.details[item])
    }
  }
  return dataArr
}

/**
 * 获取个股的右侧分时成交数据_sse推送
 * @param stockCode market.code
 * @param callback 回调函数
 * @param pageSize 最新数据条数
 * @returns
 */
let fsdata_cache: any = []
export function getStockRightFSDataSSE(stockCode: string, callback: Function, pageSize = 15) {
  function dealData(data: any) {
    if (data?.data) {
      if (data.full == 1) {
        fsdata_cache = data.data.details
      } else if (data.full == 0) {
        fsdata_cache = fsdata_cache.concat(data.data.details).slice(-pageSize)
      }
      callback(fsdata_cache.slice(0).reverse())
    }
  }
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/stock/details/sse?fields1=f1,f2,f3,f4&fields2=f51,f52,f53,f54,f55&mpi=1000&ut=${ut}&fltt=2&pos=-${pageSize}&secid=${stockCode}${delayparams}`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }

  return sse
}

/**
 * 获取个股的盘口成交明细数据_sse推送
 * @param stockCode market.code
 * @param callback 回调函数
 * @param pageSize 最新数据条数
 * @returns
 */
let pktradedata_cache: any = []
export function getStockPKTradeDataSSE(stockCode: string, callback: Function, pageSize = 15) {
  function dealData(data: any) {
    if (data?.data) {
      if (data.full == 1) {
        pktradedata_cache = data.data.details
      } else if (data.full == 0) {
        pktradedata_cache = pktradedata_cache.concat(data.data.details).slice(-pageSize)
      }
      callback(pktradedata_cache.slice(0).reverse())
    }
  }
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/stock/details/sse?fields1=f1,f2,f3,f4&fields2=f51,f52,f53,f54,f55&mpi=1000&ut=${ut}&fltt=2&pos=-${pageSize}&secid=${stockCode}${delayparams}`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }

  return sse
}

export function getMarketSource(quoteCode: string) {
  let result = $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/get?" + delayparams,
    data: {
      secid: quoteCode,
      fields: "f107,f111,f181,f182",
      ut,
    },
    async: false,
  })
  let data = JSON.parse(result.responseText)
  return data.data
}

let isfirst = "first"
export async function loadZsData(zcode: string, zmk: number, other: string) {
  isfirst = other
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/get?cb=?",
    data: {
      secid: zmk + "." + zcode,
      forcect: 1,
      fields: "f43,f44,f45,f46,f47,f48,f49,f50,f51,f52,f57,f58,f59,f60,f71,f84,f85,f92,f107,f108,f116,f117,f119,f127,f152,f161,f162,f163,f164,f165,f167,f168,f169,f170,f172,f173,f174,f175,f176,f198",
      ut,
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })

  if (backdata && backdata?.data) {
    return backdata.data
  }
  return null
}

/**
 * 获取个股更多页面盘口基本信息
 * @param quotecode
 * @param fields
 * @param dect
 * @returns
 */
export async function getStockMorePankouData(quotecode: string, fields: string, dect = 0) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/get?cb=?",
    data: {
      secid: quotecode,
      forcect: 1,
      invt: 2,
      fields,
      ut,
      dect
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })

  if (backdata && backdata?.data) {

    //CME合规处理
    if(thisuser == null && (quotecode.indexOf('101.') == 0  || quotecode.indexOf('102.') == 0  || quotecode.indexOf('103.') == 0)){
      Object.keys(backdata.data).forEach(function(key:any){
        if(key == 'f107' || key == 'f58' || key == 'f57'){
        }
        else{
            backdata.data[key] = '-'
        }
      })
    }


    return backdata.data
  }
  return null
}
/**
 * 获取个股更多页面盘口基本信息_推送
 * @param quotecode
 * @param fields
 * @returns
 */
let pkdata_cache = {}
export function getStockMorePankouDataSSE(quotecode: string, fields: string, callback: Function) {
  function dealData(data: any) {
    if (data.full == 1 && data.data) {
      pkdata_cache = data.data
    } else if (data.full == 0 && data.data) {
      pkdata_cache = merge({}, pkdata_cache, data.data)
    }
    callback(pkdata_cache)
  }
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/stock/sse?secid=${quotecode}&forcect=1&fields=${fields}&ut=${ut}&fltt=1&invt=2&mpi=1000${delayparams}`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }
  return sse
}

/**
 * 获取个股更多页面分时成交数据
 * @param quotecode
 * @param fields
 * @returns
 */
export async function getStockMoreFSData(quotecode: string, pageNumber: number) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/details/get?cb=?",
    data: {
      secid: quotecode,
      forcect: 1,
      invt: 2,
      pos: `-${pageNumber + 1}`,
      iscca: 1,
      fields1: "f1,f2,f3,f4,f5",
      fields2: "f51,f52,f53,f54,f55",
      ut,
    },
    dataType: "jsonp",
  })
  let dataArr: Array<string> = []
  if (backdata != null && backdata.data != null && backdata.data.details != null && backdata.data.details.length > 0) {
    for (let item = backdata.data.details.length - 1; item >= 0; item--) {
      dataArr.push(backdata.data.details[item])
    }
  }
  return dataArr
}

/**
 * 获取更多页面分时成交数据_sse推送
 * @param stockCode market.code
 * @param callback 回调函数
 * @param pageSize 最新数据条数
 * @returns
 */
let pk_fsdata_cache: any = []
export function getStockMoreFSTradeDataSSE(stockCode: string, callback: Function, pageSize: number) {
  function dealData(data: any) {
    if (data?.data) {
      if (data.full == 1) {
        pk_fsdata_cache = data.data.details
      } else if (data.full == 0) {
        pk_fsdata_cache = pk_fsdata_cache.concat(data.data.details).slice(-pageSize)
      }
      callback(pk_fsdata_cache.slice(0).reverse())
    }
  }
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/stock/details/sse?fields1=f1,f2,f3,f4,f5&fields2=f51,f52,f53,f54,f55&forcect=1&ut=${ut}&invt=2&iscca=1&fltt=2&pos=-${pageSize + 1}&secid=${stockCode}${delayparams}&mpi=1000`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }

  return sse
}

/**
 * 获取相关品种行情数据
 * @param quotecode
 * @param fields
 * @returns
 */
export async function getStockRelevantTypeData(quotecode: string, pagesize = 10, po = 1) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/multi/get?cb=?",
    data: {
      secid: quotecode,
      fltt: 2,
      po,
      invt: 2,
      spt: 4,
      fid: "f3",
      rt4: "fields=f43,f57,f58,f59,f107,f152,f169,f170",
      rt18: "fields=f1,f12,f13,f14,f2,f3,f4,f152",
      reqt: 7,
      np: 1,
      pn: 1,
      pz: pagesize,
      ut,
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })

  if (backdata && backdata?.data) {
    return backdata.data
  }
  return null
}

/**
 * 获取所属板块行情数据
 * @param quotecode
 * @param fields
 * @returns
 */
export async function getStockBKData(quotecode: string, fields: string) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/slist/get?cb=?",
    data: {
      secid: quotecode,
      pi: 0,
      po: 1,
      forcect: 1,
      invt: 2,
      spt: 3,
      fid: "f3",
      pz: 30,
      fid0: "f4003",
      fields,
      np: 1,
      ut,
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })

  if (backdata && backdata?.data) {
    return backdata.data
  }
  return null
}

/**
 * 获取相关组合数据
 * @param market
 * @param code
 * @param pageSize
 * @returns
 */
export async function getStockRelevantGroupData(market: number, code: string, pageSize: number) {
  let backdata = await $.ajax({
    type: "get",
    async: false,
    url: "https://moniapi.eastmoney.com/zuheV64/JS.aspx?cb=?",
    dataType: "jsonp",
    jsonpCallback: "zuhecb", //设置回调函数的名称，和要请求的js中函数名称一致
    data: {
      type: "stk_hold_of_zuhe",
      mkt: market,
      code,
      recIdx: pageSize - 20,
      recCnt: 20,
      js: "zuhecb((x))",
    },
    error: function (e) {
      // console.log(e);
    },
  })

  return backdata
}

/**
 * 获取板块成分股行情数据_推送
 * @param quotecode
 * @param fields
 * @returns
 */
let cfgdata_cache = {}
export function getStockCFGDataSSE(code: string, param: { cmd: string, pindex: number, psize: number, sr: number, st: string }, callback: Function) {
  function dealData(data: any) {
    if (data.full == 1 && data.data) {
      cfgdata_cache = data.data
    } else if (data.full == 0 && data.data) {
      cfgdata_cache = merge({}, cfgdata_cache, data.data)
    }
    callback(cfgdata_cache)
  }
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/clist/sse?ut=${ut}&forcect=1&fs=b:${code}&pn=1&pz=${param.psize}&po=${param.sr}&fid=${param.st}&invt=2&mpi=1000${delayparams}`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }
  return sse
}

/**
 * 获取沪深京指数成分股行情数据_推送
 * @param quotecode
 * @param fields
 * @returns
 */
let hs_cfgdata_cache = {}
export function getIndexCFGDataSSE(code: string, param: { cmd: string, pindex: number, psize: number, sr: number, st: string }, callback: Function) {
  function dealData(data: any) {
    if (data.full == 1 && data.data) {
      hs_cfgdata_cache = data.data
    } else if (data.full == 0 && data.data) {
      hs_cfgdata_cache = merge({}, hs_cfgdata_cache, data.data)
    }
    callback(hs_cfgdata_cache)
  }
  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/slist/sse?ut=${ut}&fltt=1&fields=f1,f2,f3,f4,f12,f13,f14,f152&secid=${code}&invt=2&pz=${param.psize}&po=${param.sr}&fid=${param.st}&mpi=1000&spt=11&pn=1${delayparams}`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }
  return sse
}

/**
 * 获取指数成分股行情数据
 * @param quotecode
 * @param fields
 * @returns
 */
 export async function getIndexCFGData(quotecode: string,  param: { cmd: string, pindex: number, psize: number, sr: number, st: string }) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + `api/qt/slist/get?cb=?${delayparams}`,
    data: {
      secid: quotecode,
      fltt:1,
      fields:"f1,f2,f3,f4,f12,f13,f14,f152",
      invt: 2,
      fid: param.st,
      pz:param.psize,
      po: param.sr,
      np:1,
      spt: 11,
      pn:1,
      ut,
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })

  if (backdata && backdata?.data) {
    return backdata.data
  }
  return null
}

/**
 * 获取买卖盘行情数据_推送
 * @param quotecode
 * @param callback
 * @returns
 */
let mmpdata_cache: any = {}
export function getStockMMPDataSSE(quotecode: string, callback: Function) {
  function dealData(data: any) {
    if (data.full == 1 && data.data) {
      mmpdata_cache = data.data
    } else if (data.full == 0 && data.data) {
      mmpdata_cache = merge({}, mmpdata_cache, data.data)
    }
    let sellArr:any = []
    let buyArr:any = []

    if (mmpdata_cache != "" && mmpdata_cache?.brkq?.length) {
      mmpdata_cache.brkq.map((item: any) => {
        if (item != "") {
          if (item.substr(0, 1) == "S") {
            item = item.split(":")[1]
            item.split(",").map((v: any, index: number) => {
              sellArr.push(item.split(",")[index])
            })
          } else if (item.substr(0, 1) == "B") {
            item = item.split(":")[1]
            item.split(",").map((v: any, index: number) => {
              buyArr.push(item.split(",")[index])
            })
          }
        }
      })
    }
    let result = {
      "Sell":sellArr,
      "Buy":buyArr
    }
    callback(result)
  }

  let sse = new EventSource(`${quoteUrl.getPath("quote_sse")}api/qt/stock/brkq/sse?ut=${ut}&secid=${quotecode}&forcect=1&invt=2&fields=f1,f2,f3,f4,f5&mpi=1000${delayparams}`)

  sse.onmessage = function (output) {
    let data = JSON.parse(output.data)
    if (data.data != null) dealData(data)
  }
  return sse
}

/**
 * 获取买卖盘行情数据
 * @param quotecode
 * @returns
 */
export async function getStockMMPData(quotecode: string) {
  let backdata = await $.ajax({
    type: "get",
    url: quoteUrl.getPath("quote") + "api/qt/stock/brkq/get?cb=?" + delayparams,
    data: {
      secid: quotecode,
      forcect:1,
      invt:2,
      fields:"f1,f2,f3,f4,f5",
      ut,
    },
    dataType: "jsonp",
    error: function (e) {
      // console.log(e);
    },
  })

  if (backdata?.data?.brkq?.length) {
    let sellArr:any = []
    let buyArr:any = []
     backdata.data.brkq.map((item: any) => {
      if (item != "") {
        if (item.substr(0, 1) == "S") {
          item = item.split(":")[1]
          item.split(",").map((v: any, index: number) => {
            sellArr.push(item.split(",")[index])
          })
        } else if (item.substr(0, 1) == "B") {
          item = item.split(":")[1]
          item.split(",").map((v: any, index: number) => {
            buyArr.push(item.split(",")[index])
          })
        }
      }
    })
    let result = {
      "Sell":sellArr,
      "Buy":buyArr
    }
    return result
  }
  return null
}

/**
 * 获取报价逐笔申报数据
 * @param quotecode
 * @param fields2
 * @returns
 */
 export async function getBondZBSBData(quotecode: string, field2:object , pageSize=20,) {
  let backdata = await $.ajax({
    url: quoteUrl.getPath('quote')+'api/qt/bond/order/get?',
    type: 'get',
    dataType: 'json',
    data: {
      dpt:'wz.bondup',
      lmt:pageSize,
      fields1:"f1,f2,f3,f4,f5",
      secid:quotecode,
      ...field2,
      ut,
    },
    error: function (e) {
      // console.log(e);
    },
  })

  return backdata
}

/**
 * 获取报价逐笔成交数据
 * @param quotecode
 * @param fields2
 * @returns
 */
 export async function getBondZBCJData(quotecode: string, field2:object , pageSize=20,) {
  let backdata = await $.ajax({
    url: quoteUrl.getPath('quote')+'api/qt/bond/trans/get?',
    type: 'get',
    dataType: 'json',
    data: {
      dpt:'wz.bondup',
      minvol:'0',
      pos:'-10',
      lmt:pageSize,
      fields1:"f1,f2,f3,f4,f5",
      ...field2,
      secid:quotecode,
      ut,
    },
    error: function (e) {
      // console.log(e);
    },
  })

  return backdata
}
